import React from "react";
import FieldError from "./FieldError";
import Label from "./Label";
import type { TextFieldProps } from "./TextField";
import TextField from "./TextField";

type SearchInputProps = Omit<
  TextFieldProps,
  "appendElement" | "type" | "iconName" | "error"
> & {
  error?: string;
  label?: React.ReactElement | string;
};

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      required = true,
      defaultValue = undefined,
      label,
      id,
      autocomplete = "off",
      value = undefined,
      placeholder,
      error,
      pattern,
      disabled,
      tabIndex = undefined,
      onChange,
      onBlur,
      readOnly,
      onClick,
      onIconClick,
      onKeyDown,
      autoFocus,
      onFocus,
    }: SearchInputProps,
    ref,
  ) => {
    return (
      <div className="relative block w-full space-y-2">
        <Label id={id} required={required} label={label} disabled={disabled} />
        <TextField
          ref={ref}
          id={id}
          type="search"
          defaultValue={defaultValue}
          required={required}
          autocomplete={autocomplete}
          value={value}
          pattern={pattern}
          placeholder={placeholder}
          disabled={disabled}
          tabIndex={tabIndex}
          onChange={onChange}
          onBlur={onBlur}
          onClick={onClick}
          onIconClick={onIconClick}
          readOnly={readOnly}
          iconName="magnifying-glass"
          error={error}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
          userAgentAppearance={false}
          onFocus={onFocus}
        />
        <FieldError error={error} />
      </div>
    );
  },
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
